/* ============================================================================
   ff-showcase.js · JANFEATURED (Jan, 2026-10-02)

   "i want their stories and all of that to be easily be able to be grabbed so
   like if i reference it in battlegrounds or in blogs or interactive things it
   auto just picks from those characters ... always uses those characters by
   default at first and if i want more then it grabs the rest of the ff
   portraits ... a special list i can keep adding to".

   ONE place for any page to borrow Hall heroes to show off. The list is Jan's
   featured: heroes Jan ticks "Jan's featured" on in the Hall's debug-mode card
   view (saved on the hero as quest_meta.jan_featured). When a page wants more
   heroes than that list holds, the other FramedFantasy portraits fill in.
   Hidden or unapproved heroes and heroes without art never appear.

   Load it on a page that needs heroes:
     <script src="{{ 'ff-showcase.js' | asset_url }}" defer></script>
   Then:
     ffShowcase.get({ count: 12 }).then(function (heroes) { ... });
     ffShowcase.get({ count: 6, fill: false });       // Jan's featured only
     ffShowcase.get({ count: 20, stories: false });   // lighter: no story text
     ffShowcase.get({ count: 8, shuffle: false });    // newest first, no shuffle
     ffShowcase.get({ count: 200, cards: true });     // + the Hall card's words
   Each hero:
     { id, slug, name, race, characterClass, level, campaign, playerName,
       story, image, thumb, offsetX, offsetY, zoom, imageStyle, isFF,
       janFeatured, url, createdAt, card, video }
   card is the Hall card's card_meta ({ epithet, title, legend, quote, order,
   edited }) and video a Living Motion URL; both only with cards:true.
   offsetX / offsetY (0-100, 50 = centre) and zoom (percent, 100 = none) are
   the Hall reframe; imageStyle is the ready style for an object-fit:cover
   <img>, so the portrait crops exactly as it does in the Hall. url is the
   hero's page. Order: Jan's featured first, then FramedFantasy portraits,
   each group shuffled unless shuffle:false. It never rejects: a failure
   resolves to [] so a page can hide its strip.

   It is for NEW things (Jan, 2026-10-02: "dont replace the scrolling images of
   featured characters from the hall with my current list, its just in the
   future when i build out more things"). The existing strips (the Hall
   marquee, ff-hall-spotlight, hall-of-heroes-preview) keep their own picks.
   The home hero's card deck (ff-hero-cards, Jan 2026-10-15: "cycle ... through
   all of jan's favorites from the hall") reads the list with cards:true.
   A raw PostgREST read of the list:
     /rest/v1/characters?select=...&quest_meta->>jan_featured=eq.true
   ============================================================================ */
(function () {
  if (window.ffShowcase) return;
  var REST = 'https://obadckrukccwkjgpbsxa.supabase.co/rest/v1/characters';
  var KEY = 'sb_publishable_4DntR53dZydUazuyuPI3YQ_zg69PLYZ';
  var HDRS = { apikey: KEY, Authorization: 'Bearer ' + KEY };
  var LIGHT = 'id,name,slug,race,character_class,dnd_level,level,campaign,player_name,image_url,image_thumb_url,image_offset_x,image_offset_y,image_zoom,is_ff_portrait,created_at,jan_featured:quest_meta->jan_featured';
  var CARD = ',card_meta,video_url,is_animated';
  var VISIBLE = '&approved=eq.true&or=(is_hidden.is.null,is_hidden.eq.false)&image_url=not.is.null';
  var HERO_PAGE = '/pages/hero';
  var cache = {};

  function read(query) {
    return fetch(REST + '?' + query, { headers: HDRS })
      .then(function (r) { return r.ok ? r.json() : []; })
      .catch(function () { return []; });
  }
  function shuffle(a) {
    for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; }
    return a;
  }
  function num(v, d) { if (v == null || v === '') return d; v = Number(v); return isFinite(v) ? v : d; }
  function shape(r, story) {
    var ref = r.slug || r.id, x = num(r.image_offset_x, 50), y = num(r.image_offset_y, 50), z = num(r.image_zoom, 100);
    return {
      id: r.id, slug: r.slug || null, name: r.name || '', race: r.race || '', characterClass: r.character_class || '',
      level: r.dnd_level || r.level || null, campaign: r.campaign || '', playerName: r.player_name || '',
      story: story == null ? null : String(story), image: r.image_url || '', thumb: r.image_thumb_url || r.image_url || '',
      offsetX: x, offsetY: y, zoom: z,
      imageStyle: 'object-position:' + x + '% ' + y + '%;transform-origin:' + x + '% ' + y + '%;scale:' + (z / 100) + ';',
      isFF: r.is_ff_portrait === true, janFeatured: r.jan_featured === true,
      url: ref ? HERO_PAGE + '?h=' + encodeURIComponent(ref) : '',
      createdAt: r.created_at || '',
      card: r.card_meta && typeof r.card_meta === 'object' ? r.card_meta : null,
      video: r.is_animated === true && r.video_url ? String(r.video_url) : ''
    };
  }
  function get(opts) {
    opts = opts || {};
    var count = Math.max(1, Math.min(200, Math.floor(num(opts.count, 12))));
    var fill = opts.fill !== false, stories = opts.stories !== false, mix = opts.shuffle !== false;
    var cards = opts.cards === true;
    var key = [count, fill, stories, mix, cards].join('|');
    if (cache[key]) return cache[key];
    var order = '&order=created_at.desc', cols = LIGHT + (cards ? CARD : '');
    cache[key] = Promise.all([
      read('select=' + cols + VISIBLE + '&quest_meta->>jan_featured=eq.true' + order + '&limit=200'),
      fill ? read('select=' + cols + VISIBLE + '&is_ff_portrait=eq.true' + order + '&limit=400') : Promise.resolve([])
    ]).then(function (res) {
      var featured = res[0] || [], seen = {};
      featured.forEach(function (r) { seen[r.id] = 1; });
      var rest = (res[1] || []).filter(function (r) { return !seen[r.id]; });
      if (mix) { shuffle(featured); shuffle(rest); }
      var picked = featured.concat(rest).slice(0, count);
      if (!stories || !picked.length) return picked.map(function (r) { return shape(r, null); });
      /* the stories ride a second read for just the heroes picked */
      return read('select=id,story&id=in.(' + picked.map(function (r) { return r.id; }).join(',') + ')')
        .then(function (rows) {
          var byId = {};
          (rows || []).forEach(function (s) { byId[s.id] = s.story; });
          return picked.map(function (r) { return shape(r, byId[r.id] == null ? '' : byId[r.id]); });
        });
    }).catch(function () { delete cache[key]; return []; });
    return cache[key];
  }
  window.ffShowcase = { get: get };
})();
